export enum PaymentListSortBy {
    None = 0,
    TypeAsc = 1,
    TypeDesc = 2,
    CreatedAsc = 3,
    CreatedDesc = 4,
    AmountAsc = 5,
    AmountDesc = 6,
}